import { concatArrays } from '@iotize/common/array';
import { KaitaiStreamWriter } from '@iotize/common/byte-stream';
import { Subject } from 'rxjs';
import { map, skipWhile, take } from 'rxjs/operators';
import { debug } from '../debug';
const TAG = 'BufferQueue';
export class BufferQueue {
    constructor() {
        this._buffer = new Uint8Array(0);
        this.subject = new Subject();
    }
    get buffer() {
        return this._buffer;
    }
    set buffer(b) {
        this._buffer = b;
    }
    /**
     * Append data to the buffer
     * @param data
     */
    next(data) {
        this._buffer = concatArrays(this._buffer, data);
        // console.debug("BUFFER LENGTH", this._buffer.length)
        this.subject.next(data);
    }
    /**
     * Take at max length bytes data from the buffer.
     * @param length
     */
    take(length) {
        // console.debug("TAKE BUFFER LENGTH", this._buffer.length)
        const maxLength = Math.min(length, this._buffer.length);
        const result = this._buffer.slice(0, maxLength);
        this._buffer = this._buffer.slice(maxLength);
        // console.debug("TAKE ", length, "NEW LENGTH: ", this._buffer.length)
        return result;
    }
    /**
     * Returns the buffer length
     */
    dataLength() {
        return this._buffer.length;
    }
    /**
     * Returns the whole buffer
     */
    takeAll() {
        return this.take(this.dataLength());
    }
    /**
     * Returns a promise that resolve when buffer has received the expectedLength given in parameter
     * @param expectedLength expected length in bytes that we must receive before resolving the promise
     */
    waitforLength(expectedLength) {
        const data = this.take(expectedLength);
        if (data.length === expectedLength) {
            return Promise.resolve(data);
        }
        const remainingLength = expectedLength - data.length;
        debug(TAG, 'waitforLength', `Request ${expectedLength}. Buffer length: ${data.length}. Remaining: ${remainingLength}`);
        return this.subject
            .pipe(
        // tap(console.info),
        skipWhile((value) => {
            const condition = this._buffer.length < remainingLength;
            debug(TAG, 'waitforLength', `Request ${remainingLength}. takeWhile: ${condition}`);
            return condition;
        }), take(1), map((val) => {
            return KaitaiStreamWriter.mergeArrays(data, this.take(remainingLength));
        }))
            .toPromise();
    }
}
